<ui-image-info
  imageSrc="icon_403"
  i18n-header="@@ACCESS_DENIED"
  header="Access denied"
  [descriptions]="descriptionImageInfo"
  [maxWidth]="400"
></ui-image-info>
